export type SpecialGuestSocialLink = { platform: string; label: string; url: string };

export type SpecialGuestRow = {
  name: string;
  title?: string;
  description?: string;
  photo?: string;
  socialLinks?: SpecialGuestSocialLink[];
};

function normalizeRawList(raw: unknown): unknown[] {
  if (raw == null) return [];
  if (typeof raw === "string") {
    const trimmed = raw.trim();
    if (!trimmed) return [];
    try {
      const parsed: unknown = JSON.parse(trimmed);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return Array.isArray(raw) ? raw : [];
}

/** product.metas.special_guests (API genişletilmiş veya ham) → kart listesi */
export function parseSpecialGuestsFromProduct(
  product: { metas?: Record<string, unknown> } | null | undefined,
  transformMediaUrl: (url: string) => string | undefined,
): SpecialGuestRow[] {
  const raw = product?.metas?.special_guests;
  const list = normalizeRawList(raw);
  const guests: SpecialGuestRow[] = [];

  for (const item of list) {
    if (item == null || typeof item !== "object") continue;
    const row = item as Record<string, unknown>;
    const name = String(row.name ?? "").trim();
    if (!name) continue;

    const guest: SpecialGuestRow = { name };

    if (row.photo != null && String(row.photo).trim()) {
      const photoRaw = String(row.photo).trim();
      guest.photo = transformMediaUrl(photoRaw) ?? photoRaw;
    } else if (row.photo_media_id != null) {
      const id = Number(row.photo_media_id);
      if (Number.isFinite(id) && id > 0) {
        const proxy = `/api/media/proxy/${id}?size=xlarge`;
        guest.photo = transformMediaUrl(proxy) ?? proxy;
      }
    }

    const title = row.title != null ? String(row.title).trim() : "";
    if (title) guest.title = title;

    const description = row.description != null ? String(row.description).trim() : "";
    if (description && description.replace(/<[^>]*>/g, "").trim()) {
      guest.description = description;
    }

    const socialRaw = row.social_links;
    if (Array.isArray(socialRaw)) {
      const socialLinks: SpecialGuestSocialLink[] = [];
      for (const link of socialRaw) {
        if (link == null || typeof link !== "object") continue;
        const l = link as Record<string, unknown>;
        const url = String(l.url ?? l.profile_url ?? "").trim();
        if (!url) continue;
        const label = String(l.label ?? l.platform_other ?? l.platform ?? "").trim() || url;
        socialLinks.push({
          platform: String(l.platform ?? "other"),
          label,
          url,
        });
      }
      if (socialLinks.length) guest.socialLinks = socialLinks;
    }

    guests.push(guest);
  }

  return guests;
}
